import { Icon } from "./icons";
import { T } from "../i18n";

// Honest UI states shared across every surface: loading, error (keeps last known
// state), empty/no-match, partial-coverage, and the embedded connecting state. A
// partial result is never shown as if it were complete (GY-031/GY-033). Each is a
// centered icon + title + explanation rather than a bare line of gray text.

export function Loading() {
  return (
    <div className="state state-loading" role="status" aria-live="polite">
      <span className="state-icon"><Icon.dot size={22} /></span>
      <span className="state-title">{T.common.loading}</span>
    </div>
  );
}

export function ErrorState({ onRetry }: { onRetry?: () => void }) {
  return (
    <div className="state state-error" role="alert">
      <span className="state-icon"><Icon.bell size={22} /></span>
      <span className="state-title">{T.common.error}</span>
      {onRetry && (
        <button onClick={onRetry} className="btn-icon">
          <Icon.reset size={15} />
          {T.common.retry}
        </button>
      )}
    </div>
  );
}

export function EmptyState({ message }: { message: string }) {
  return (
    <div className="state state-empty" role="status">
      <span className="state-icon"><Icon.search size={22} /></span>
      <span className="state-sub">{message}</span>
    </div>
  );
}

export function ConnectingState({ failed }: { failed?: boolean }) {
  // Shown while the embedded app waits for the platform to relay the session
  // (and, after a timeout, if it never arrives). Honest: it says to open Graphy
  // from the platform rather than rendering an empty frame that looks broken.
  return (
    <div className={`state ${failed ? "state-error" : "state-loading"}`} role="status" aria-live="polite">
      <span className="state-icon"><Icon.brand size={22} /></span>
      <span className={failed ? "state-sub" : "state-title"}>
        {failed ? T.common.notConnected : T.common.connecting}
      </span>
    </div>
  );
}

export function PartialBanner({ message }: { message?: string }) {
  return (
    <div className="banner banner-partial" role="status">
      <Icon.dot size={14} />
      <span>{message ?? T.common.partialCoverage}</span>
    </div>
  );
}
